import { Button, styled } from '@mui/material';

const StyledButton = styled(Button)(({ theme }) => ({
    size: "small",
    minWidth: 'auto',
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius, 
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.neutral.light,
    boxShadow: 'none',
    '&:hover': {
        backgroundColor: theme.palette.neutral.light,
        filter: 'brightness(1.2)',
        boxShadow: 'none',
    },
}));

export default StyledButton;
